<template>
    <div class="info-box">
        <h3>INFORMATION</h3>
<!--         <span>
            CheckList app is an application for digitizing maintenance
            visits in supermarkets for heating, ventilation and air 
            conditioning.

            If you do not have access data yet, please register. We will 
            then get back to you as soon as possible.
        </span> -->
        <span>
            CheckList App ist eine Anwendung zur Digitalisierung
            von Wartungsbesuchen in Supermärkten für Heizung, Lüftung und Klima. 
            Wenn Sie noch keine Zugangsdaten haben, registrieren Sie sich bitte. 

            Wir werden uns dann so schnell wie möglich bei Ihnen melden.
        </span>
    </div>
</template>

<script>
    export default { name: "infoBox" }
</script>

<style scoped>
    .info-box {
        border-left: solid #1B608C 5px;
        width: 90vw;
        max-width: 900px;
        margin: 0px auto;
        margin-top: 20px;
        background-color: white;
        padding: 12px;
        box-sizing: border-box;
        -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.20);
        -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.20);
        box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.20);
    }
     h3 {
        font-weight: 400;
        font-size: 16px;
        margin-top: 0px;
    }
    span {
        font-size: 14px;
        font-weight: 300;
    }
</style>